import { approvalRequest } from './API';
import { extractApiErrorMessage } from 'src/utils/apiErrorUtils';

const ApprovalRequest = async (approvalRequestId, accessToken, action) => {

    try {
        const response = await approvalRequest(approvalRequestId, accessToken, action);
        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, data: extractApiErrorMessage(error) };
    }
};

export default ApprovalRequest;